<img
  [src]="image_url()"
  [alt]="alt()"
  [class]="css_class()"
  [style.width.px]="size()"
  [style.height.px]="size()"
  [style.border-color]="border_color()"
/>
